import { render } from "./WishList.vue?vue&type=template&id=f8dda250&scoped=true"
import script from "./WishList.vue?vue&type=script&lang=js"
export * from "./WishList.vue?vue&type=script&lang=js"

import "./WishList.vue?vue&type=style&index=0&id=f8dda250&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8dda250"]])

export default __exports__